import { useEffect } from 'react';
import { type NextPageWithLayout } from 'next';
import { useRouter } from 'next/router';
import { NoSSR } from '@/components';
import { PublicPageView } from '@/module/public/PublicPageView';
import { useIsInExternalPlatform } from '@/shared/externalPlatform';
import { getDefaultStaticProps } from '@/utils/next';
const PublicPage: NextPageWithLayout = () => {
  const isInExternalPlatform = useIsInExternalPlatform();
  const router = useRouter();
  useEffect(() => {
    if (isInExternalPlatform) {
      void router.replace('/myquiz');
    }
  }, [isInExternalPlatform, router]);
  if (isInExternalPlatform) return null;
  return <NoSSR data-sentry-element="NoSSR" data-sentry-component="PublicPage" data-sentry-source-file="index.page.tsx">
      <PublicPageView data-sentry-element="PublicPageView" data-sentry-source-file="index.page.tsx" />
    </NoSSR>;
};
export default PublicPage;
export const getStaticProps = (ctx: Parameters<typeof getDefaultStaticProps>[0]) => getDefaultStaticProps({
  ...ctx,
  namespaces: ['common', 'board', 'build']
});